import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconBellFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      d="M9.715 21h4.571M12 4.125V3"
      vectorEffect="non-scaling-stroke"
    />
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeLinejoin="round"
      d="M20 17.625H4l2.286-2.25V9.75c0-3.26 2.285-5.625 5.714-5.625 3.429 0 5.714 2.365 5.714 5.625v5.625L20 17.625Z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const Memo = memo(SvgIconBellFill);
export default Memo;
